<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="4" md="3" lg="3" xl="2">
        <v-list color="transparent" nav>
          <v-list-item-group
            v-model="selectedCategory"
            color="primary"
          >
            <v-list-item :disabled="selectedCategory === 0">Tous</v-list-item>
            <v-divider class="mb-2"></v-divider>
            <v-list-item 
              v-for="(category, index) in categories" 
              :key="'cat' + index"
              :value="category.id"
              :disabled="selectedCategory === category.id"
            >
              {{category.title}}
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
      <v-col cols="12" sm="8" md="7" lg="8" xl="6">
        <v-toolbar color="transparent" flat>
          <v-text-field 
            v-model="search" 
            color="primary" 
            placeholder="Recherche" 
            hide-details 
            prepend-inner-icon="find_in_page"
            :loading="loading || searchTimerId !== null"
          >
          </v-text-field>
        </v-toolbar>
        <v-slide-y-transition mode="out-in">
          <template v-if="!neverLoaded">
            <v-card v-if="documents.length && !loading" key="list" shaped>
              <v-list max-height="500px" style="overflow-y: auto;">
                <v-list-item v-for="(doc, index) in documents" :key="'document' + index" :href="getDocumentPath(doc.id)">
                  <v-list-item-avatar>
                    <v-icon large>picture_as_pdf</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title class="primary--text">{{doc.title}} </v-list-item-title>
                    <v-list-item-subtitle>{{doc.category.title}}</v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action class="mr-4">
                    <span class="font-weight-thin">{{doc.prettySize}}</span>
                  </v-list-item-action>

                  <v-list-item-action>
                    {{doc.prettyDate}}
                  </v-list-item-action>

                  <v-list-item-action>
                    <v-btn icon ripple :href="getDocumentPath(doc.id)">
                      <v-icon large color="primary">get_app</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <v-card-actions v-if="documents.length >= 8">
                <v-spacer></v-spacer>
                <v-btn text color="primary">Voir plus</v-btn>
              </v-card-actions>
            </v-card>
            <v-alert v-else color="primary" text icon="info" key="alert">
              Aucun document trouvé
            </v-alert>
          </template>
        </v-slide-y-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Me from '@/services/me'
import Categories from '@/services/categories'
import prettyBytes from 'pretty-bytes'
import FilesathHelpersMixin from '@/mixins/FilesPathHelpersMixin'
export default {
  mixins: [FilesathHelpersMixin],
  data: () => ({
    selectedCategory: 0,
    documents: [],
    categories: [],
    publicPath: process.env.VUE_APP_SERVER_ADDRESS + '/files/documents/',
    search: '',
    loading: false,
    neverLoaded: true,
    searchTimerId: null,
  }),
  watch: {
    selectedCategory () {
      this.fetchDocuments()
    },
    search () {
      clearTimeout(this.searchTimerId)
      this.searchTimerId = setTimeout(async () => {
        this.fetchDocuments()
        this.searchTimerId = null
      }, 500)
    }
  },
  methods: {
    async fetchDocuments () {
      this.loading = true

      const documents = await Me.getPublicDocuments(this.selectedCategory || null, this.search)
      this.documents = documents.map(doc => ({
        ...doc, 
        prettySize: prettyBytes(doc.fileSize),
        prettyDate: (new Date(doc.updatedAt)).toLocaleString('fr-FR', {day: 'numeric', month: 'long', year: 'numeric'})
      }))
      this.loading = false
    }
  },
  async created () {
    await this.fetchDocuments()
    this.categories = await Categories.getAll()
    this.neverLoaded = false
  }
}
</script>